<template>
  <div class="login-buttons__google">
    <button
      type="button"
      class="button is-medium login-buttons__btn login-buttons__btn--google"
      :disabled="busy || !ready"
      @click="start"
    >
      <Icon name="google" />
      Google
    </button>
    <p v-if="error" class="help is-danger">{{ error }}</p>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { useGoogleOAuth } from '@/auth/useGoogleOAuth'
import Icon from '@/components/Icon.vue'

export default defineComponent({
  components: { Icon },
  setup() {
    return useGoogleOAuth()
  }
})
</script>
